

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('input[type=file]').forEach(input => {
    const fileName = input.parentNode.querySelector('.file-label')
    input.addEventListener('change', event => {
      const [file] = input.files
      if (file) {
        fileName.innerHTML = file.name
      }
    })
  })
})
